export default class BankLinking {
  constructor() {
    this.statusCount = null;
    this.bankLinkingRequestsData = [];
    this.totalCount = 0;
    this.updatedBankLinkDetails = {};
    this.refreshListData = false;
  }
}
